import { Component, OnInit, Input, ViewChild } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { IStore } from "../../services/store.service";
import { ICheckoutTipForm } from "../../forms/checkout-tip-form/checkout-tip-form.component";
import { AuthService } from "src/app/auth/services/auth.service";
import { ICheckoutTermsAgreementForm } from "../../forms/checkout-terms-agreement-form/checkout-terms-agreement-form.component";
import { ICheckoutNoteForm } from "../../forms/checkout-order-note-form/checkout-order-note-form.component";
import { ICheckoutPersonalInfoForm } from "../../forms/checkout-personal-info-form/checkout-personal-info-form.component";
import { ICreditCardCvc } from "src/app/account/services/credit-card.service";
import {
  IMemberPlaceOrder,
  OrderService,
  IPlaceOrder,
  IMemberPlaceOrderShipping,
  IPlaceOrderShipping,
  IOrderShipping,
  IOrder,
} from "../../services/order.service";
//import * as momentTz from "moment-timezone";
import momentTz from 'moment-timezone';
import { IAddress } from "src/app/shared/services/address.service";
import { Storage } from "@ionic/storage";
import { AlertService } from "src/app/shared/services/alert.service";
import { LoaderService } from "src/app/shared/services/loader.service";

import { delay, finalize } from "rxjs/operators";
import { ICheckoutGiftCardForm } from "../../forms/checkout-gift-card-form/checkout-gift-card-form.component";

import { ICreditCardForm } from "src/app/shared/forms/credit-card-form/credit-card-form.component";
//import { ThrowStmt } from "@angular/compiler";
//import * as moment from "moment";
import moment from 'moment';
import {
  ProfileService,
  IProfile,
} from "src/app/account/services/profile.service";
import { SettingService } from "src/app/shared/services/setting.service";
import { AlertController } from "@ionic/angular";
import { IDoorDashDriveNotificationForm } from "../../forms/checkout-doordash-drive-form/checkout-doordash-drive-form.component";
import { ModalDisplayComponent } from "src/app/shared/components/modal-display/modal-display.component";
import { MenuService } from "../../services/menu.service";
import { CheckoutPersonalInfoFormDesktopComponent } from "../../forms/checkout-personal-info-form-desktop/checkout-personal-info-form-desktop.component";
import {GlobalPayments} from "src/assets/globalpayments-3ds.js";
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { AnalyticsService } from "src/app/shared/services/analytics.service";
import { Platform } from "@angular/cdk/platform";
import { PromotionService } from "../../services/promotion.service";
import { TranslationService } from "src/app/shared/services/translation.service";
import { ICustomerTransactionEmail } from "../../components/receipt/receipt.component";

declare var Clover: any;
declare var Clover3DS: any;

declare global {
    // Note the capital "W"
    interface Window { _3DSUtil: any; }
}

@Component({
    selector: "app-checkout-desktop-modal",
    templateUrl: "./checkout-desktop-modal.component.html",
    styleUrls: ["./checkout-desktop-modal.component.scss"],
    standalone: false
})
export class CheckoutDesktopModalComponent implements OnInit {
  title: string = "Nav.Checkout";

  @ViewChild('personalInfoForm') personalInfoFormComponent!: CheckoutPersonalInfoFormDesktopComponent;
  @Input() order: IOrder;
  @Input() store: IStore;
  

  submitted: boolean = false;
  clickedSubmitted: boolean = false;
  total: number = 0;
  shippingPrice: number;
  tip: number = 0;
  termsAgreement: ICheckoutTermsAgreementForm;
  checkoutNote: ICheckoutNoteForm;
  personalInformation: ICheckoutPersonalInfoForm;
  giftCard: ICheckoutGiftCardForm;
  eCouponCode: string;
  discountAmount: number = 0;
  memberCreditCard: ICreditCardCvc;
  guestCreditCard: ICreditCardForm;
  guestBillingAddress: IAddress;
  shippingAddress: IAddress;
  profile: IProfile;
  SendNotificationAgreement: boolean;
  isMeetAtDoor: boolean = true; // for uber direct
  orderId: string;
  threeDSTransactionId: string;
  giftTrsConsNumber: string;
  includeUtensils: boolean = false;
  cloverTokenId: string = null;

  warningModal: HTMLIonModalElement = null;

  overMinimumPickupSeatAmount: boolean = false;

  memberProfile: IProfile;

  promotionCode: string;
  discountTarget: string;
  discountAftertax: boolean;

  VisitorId: string;

  get isGiftCardFullyCover() {
    if (!this.giftCard) return false;

    if (this.giftCard.use && this.giftCard.remainingBalance <= 0) return true;

    return false;
  }

  getDiscountAmount(discountInfo: any) {
    this.discountAmount = discountInfo.amount;
    this.eCouponCode = discountInfo.couponNumber;
    this.promotionCode = discountInfo.promotionNumber;
    this.discountTarget = discountInfo.discountTarget;
    this.discountAftertax = discountInfo.discountAftertax;
  }

  get isFormValid() {
    if (!this.termsAgreement || !this.termsAgreement.agreement) return false;
    if (!this.personalInformation || !this.personalInformation._valid) {
      this.alertService.showTranslate(
        "Checkout.InvalidPersonnalInformation",
        "bottom",
        6000,
        "danger"
      );
      return false;
    }

    if (!this.store.paymentRestriction.use3DSecure &&
      this.auth.isAuthenticated &&
      !this.isGiftCardFullyCover &&
      !this.memberCreditCard &&
      this.store.cloverPaymentInfo == null
    ) {
      this.alertService.showTranslate(
        "Checkout.NoCreditCardSelected",
        "bottom",
        6000,
        "danger"
      );
      return false;
    } else if ((!this.auth.isAuthenticated || (this.auth.isAuthenticated && this.store.paymentRestriction.use3DSecure)) && this.store.cloverPaymentInfo == null) {
      if (
        !this.isGiftCardFullyCover &&
        (!this.guestBillingAddress ||
          !this.guestCreditCard ||
          !this.guestCreditCard._valid)
      ) {
        if (!this.guestCreditCard || !this.guestCreditCard._valid) {
          this.alertService.showTranslate(
            "Checkout.InvalidPaymentInformation",
            "bottom",
            6000,
            "danger"
          );
        } else if (
          !this.guestBillingAddress ||
          !this.guestBillingAddress.postalCode
        ) {
          this.alertService.showTranslate(
            "Checkout.InvalidBillingAddress",
            "bottom",
            6000,
            "danger"
          );
        }

        return false;
      }
    }

    return true;
  }

  get memberShippingForm(): IMemberPlaceOrderShipping {
    let cvn = null;
    let cardId = null;
    let giftCard = null;
    if (this.memberCreditCard) {
      cvn = this.memberCreditCard.Cvc;
      cardId = this.memberCreditCard.Card.Id;
    }

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let orderShipping: IOrderShipping = {
      orderShippingItems: this.order.orderItems.filter(
        (i) => i.orderType == this.order._deliveryType
      ),
      note: this.order.note,
    };

    return {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      cvn: cvn,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      shippingAddress: this.shippingAddress,
      note: (this.checkoutNote) ? this.checkoutNote.note : "",
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      orderShipping: orderShipping,
      phone: this.personalInformation.phone,
      orderTip: this.tip,
      savedCardId: cardId,
      giftCard: giftCard,
      //discountAmount: this.discountAmount,
      eCouponCode: this.eCouponCode,
      timeZone: momentTz().format("Z"),
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      estimatedTime:
        this.store.orderPrepareTimeMin > 0
          ? moment()
              .add(this.store.orderPrepareTimeMax, "minutes")
              .format("hh:mm A")
          : null,
      shippingPrice: this.shippingPrice,
      sendNotification: false,
      convenienceFee: this.store.convenienceFee,
      origin: this.platform.isBrowser ? 0 : 1,

      // for promotions:
      promotionCode: this.promotionCode,
      orderType: this.order._deliveryType,
      accountId: this.memberProfile?.Id ?? 0,
      visitorId: this.VisitorId,
      cloverPaymentToken: this.cloverTokenId
    };
  }

  get guestShippingForm(): IPlaceOrderShipping {
    let giftCard = null;

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let orderShipping: IOrderShipping = {
      orderShippingItems: this.order.orderItems.filter(
        (i) => i.orderType == this.order._deliveryType
      ),
      note: this.order.note,
    };

    
    let placeOrder = {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      shippingAddress: this.shippingAddress,
      //discountAmount: this.discountAmount,
      eCouponCode: this.eCouponCode,
      note: (this.checkoutNote) ? this.checkoutNote.note : "",
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      orderShipping: orderShipping,
      phone: this.personalInformation.phone,
      orderTip: this.tip,
      timeZone: momentTz().format("Z"),
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      giftCard: giftCard,
      creditCard: null,
      billingAddress: this.guestBillingAddress,
      estimatedTime:
        this.store.orderPrepareTimeMin > 0
          ? moment()
              .add(this.store.orderPrepareTimeMax, "minutes")
              .format("hh:mm A")
          : null,
      shippingPrice: this.shippingPrice,
      sendNotification: false,
      convenienceFee: this.store.convenienceFee,
      origin: this.platform.isBrowser ? 0 : 1,

      // for promotions:
      promotionCode: this.promotionCode,
      orderType: this.order._deliveryType,
      accountId: this.memberProfile?.Id ?? 0,
      visitorId: this.VisitorId,
      cloverPaymentToken: this.cloverTokenId
    };
    
    if(!this.isGiftCardFullyCover && this.cloverTokenId == null){
      placeOrder.creditCard = {
        cardHolderName: this.guestCreditCard.fullName,
        cvnNumber: this.guestCreditCard.cvc,
        expirationDate: moment(this.guestCreditCard.expirationDate).format("YYYY-MM-DD"),
        number: this.guestCreditCard.number,
        type: this.guestCreditCard.type
      }
    }

    return placeOrder
  }

  get memberForm(): IMemberPlaceOrder {
    let cvn = null;
    let cardId = null;
    let giftCard = null;
    if (this.memberCreditCard) {
      cvn = this.memberCreditCard.Cvc;
      cardId = this.memberCreditCard.Card.Id;
    }

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let order: IOrder = {
      orderItems: this.order.orderItems.filter(
        (i) => i.orderType == this.order._deliveryType
      ),
      note: this.order.note,
      store: this.order.store,
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      _deliveryType: this.order._deliveryType,
    };

    return {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      cvn: cvn,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      deliveryAddress: this.shippingAddress,
      deliveryNote: (this.checkoutNote) ? this.checkoutNote.note : "",
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      order: order,
      phone: this.personalInformation.phone,
      orderTip: this.tip,
      savedCardId: cardId,
      giftCard: giftCard,
      //discountAmount: this.discountAmount,
      eCouponCode: this.eCouponCode,
      timeZone: momentTz().format("Z"),
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      estimatedTime:
        this.store.orderPrepareTimeMin > 0
          ? moment()
              .add(this.store.orderPrepareTimeMax, "minutes")
              .format("hh:mm A")
          : null,
      deliveryPrice: this.store.deliveryPrice ?? 0,
      sendNotification:
        this.store.isDoorDashDrive && this.order._deliveryType == "delivery"
          ? this.SendNotificationAgreement
          : false,
      convenienceFee: this.store.convenienceFee,
      ipAddress: this.settingService.ipAddress,
      isMeetAtDoor: this.store.isUberDirect && this.order._deliveryType == "delivery" ? this.isMeetAtDoor : false,
      includeUtensils: this.includeUtensils,
      seatInfo: this.order._seatInfo,
      origin: this.platform.isBrowser ? 0 : 1,

      // for promotions:
      promotionCode: this.promotionCode,
      orderType: this.order._deliveryType,
      accountId: this.memberProfile?.Id ?? 0,
      visitorId: this.VisitorId,
      cloverPaymentToken: this.cloverTokenId
    };
  }

  get guestForm(): IPlaceOrder {
    let giftCard = null;

    if (this.giftCard) {
      giftCard = this.giftCard.cardNumber;
    }

    let order: IOrder = {
      orderItems: this.order.orderItems.filter(
        (i) => i.orderType == this.order._deliveryType
      ),
      note: this.order.note,
      store: this.order.store,
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      _deliveryType: this.order._deliveryType,
    };

    // setting up the isMember:
    var memberVal = false;
    if(this.memberProfile?.Id) {
      // this is to fix the irregular behavior of the id being a string but then turning into a number
      if(Number(this.memberProfile?.Id) > 0) {
        var memberVal = true;
      }
    }

    let placeOrder: IPlaceOrder = {
      customerName: `${this.personalInformation.firstName} ${this.personalInformation.lastName}`,
      customerFirstName: this.personalInformation.firstName,
      customerLastName: this.personalInformation.lastName,
      customerEmail: this.personalInformation.email,
      language: this.translationService.getLanguage(),
      deliveryAddress: this.shippingAddress,
      //discountAmount: this.discountAmount,
      eCouponCode: this.eCouponCode,
      deliveryNote: (this.checkoutNote) ? this.checkoutNote.note : "",
      merchantId: this.store.merchantId,
      storeId: this.store.id,
      order: order,
      phone: this.personalInformation.phone,
      orderTip: this.tip,
      timeZone: momentTz().format("Z"),
      orderDate: this.order.orderDate,
      orderTime: this.order.orderTime,
      giftCard: giftCard,
      creditCard: null,
      billingAddress: this.guestBillingAddress,
      estimatedTime:
        this.store.orderPrepareTimeMin > 0
          ? moment()
              .add(this.store.orderPrepareTimeMax, "minutes")
              .format("hh:mm A")
          : null,
      deliveryPrice: this.store.deliveryPrice ?? 0,
      sendNotification:
        this.store.isDoorDashDrive && this.order._deliveryType == "delivery"
          ? this.SendNotificationAgreement
          : false,
      convenienceFee: this.store.convenienceFee,
      ipAddress: this.settingService.ipAddress,
      orderId: this.orderId,
      threeDSTransactionId: this.threeDSTransactionId,
      giftCardConsNumber: this.giftTrsConsNumber,
      includeUtensils: this.includeUtensils,
      seatInfo: this.order._seatInfo,
      origin: this.platform.isBrowser ? 0 : 1,

      // for promotions:
      promotionCode: this.promotionCode,
      orderType: this.order._deliveryType,
      accountId: this.memberProfile?.Id ?? 0,
      isMember: memberVal,
      visitorId: this.VisitorId,
      cloverPaymentToken: this.cloverTokenId
    };
    if(!this.isGiftCardFullyCover && this.cloverTokenId == null){
      placeOrder.creditCard = {
        cardHolderName: this.guestCreditCard.fullName,
        cvnNumber: this.guestCreditCard.cvc,
        expirationDate: moment(this.guestCreditCard.expirationDate).format("YYYY-MM-DD"),
        number: this.guestCreditCard.number,
        type: this.guestCreditCard.type
      }
    }
    return placeOrder;
  }

  get subTotal(): number {
    let subTotal = 0;
    this.order.orderItems.forEach((item) => {
      if (item.orderType == this.order._deliveryType) {
        subTotal += item.price * item.quantity;
        item.options.forEach((option) => {
          subTotal +=
            (option.itemDetailCombination
              ? option.itemDetailCombination.price
              : option.price) *
            (option.quantity == null ? 1 : option.quantity) *
            (option.itemDetailCombination ? 1 : item.quantity);
        });
      }
    });
    return subTotal;
  }

  get totalOptions() {
    // edit this to actually move the discount around
    //console.log(this.store);

    if(this.discountTarget == "order"){
      return {
        hasDelivery: this.order._deliveryType == "delivery",
        deliveryFee: this.order.store.deliveryPrice,
        //subTotal: this.subTotal - this.discountAmount, 
        subTotal: this.discountAftertax ? this.subTotal : this.subTotal - this.discountAmount,
        taxes: this.store.provinceTaxes,
        tip: this.tip,
        freeDelivery: this.store.freeDelivery,
        convenienceFee: this.store.convenienceFee,
      };
    } else if(this.discountTarget == "item") {
      return {
        // may need to send the discounted item here as well (then you match the item and simply apply the discount on it)
        hasDelivery: this.order._deliveryType == "delivery",
        deliveryFee: this.order.store.deliveryPrice,
        //subTotal: this.subTotal - this.discountAmount,
        subTotal: this.discountAftertax ? this.subTotal : this.subTotal - this.discountAmount,
        taxes: this.store.provinceTaxes,
        tip: this.tip,
        freeDelivery: this.store.freeDelivery,
        convenienceFee: this.store.convenienceFee,
      };
    } else if(this.discountTarget == "deliveryfee") {
      // the promotion gives discount on delivery fee. HOWEVER, this may cause issues if you have a discount on delivery fee and have a free delivery also

      return {
        hasDelivery: this.order._deliveryType == "delivery",
        //deliveryFee: this.order.store.deliveryPrice,
        deliveryFee: this.order.store.deliveryPrice - this.discountAmount, 
        subTotal: this.subTotal,
        taxes: this.store.provinceTaxes,
        tip: this.tip,
        freeDelivery: this.store.freeDelivery,
        convenienceFee: this.store.convenienceFee,
      };
    } else {
      return {
        hasDelivery: this.order._deliveryType == "delivery",
        deliveryFee: this.order.store.deliveryPrice,
        //subTotal: this.subTotal - this.discountAmount,
        subTotal: this.discountAftertax ? this.subTotal : this.subTotal - this.discountAmount,
        taxes: this.store.provinceTaxes,
        tip: this.tip,
        freeDelivery: this.store.freeDelivery,
        convenienceFee: this.store.convenienceFee,
      };
    }
  }

  get freeDelivery() {
    if (this.order._deliveryType == "delivery") {
      if (this.store.freeDelivery) {
        return this.store.freeDelivery;
      }
    }
  }

  get deliveryPrice() {
    if (this.order._deliveryType == "delivery") {
      return this.store.deliveryPrice;
    }
  }

  get secureUrl() {
    return `assets/imgs/checkout/Secure-SSL-${this.translationService.getLanguage()}.png`;
  }

  get isDelivery() {
    return this.order._deliveryType == "delivery";
  }

  get estimatedTime(){
    let currentDate = new Date();
    return new Date(currentDate.getTime() + this.store.orderPrepareTimeMax * 60000);
  }

  get hasAlcohol(){
    if(this.order){
      let index = this.order.orderItems.findIndex(item => item.orderType == this.order._deliveryType && item.isAlcohol);
      return index > -1;
    }
    return false;
  }

  constructor(
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    //private translateService: TranslateService,
    public auth: AuthService,
    private storage: Storage,
    private orderService: OrderService,
    private toastCtrl: ToastController,
    private loader: LoaderService,
    private profileService: ProfileService,
    private alertService: AlertService,
    public settingService: SettingService,
    private loadingCtrl: LoadingController,
    private analytics: AnalyticsService,
    private platform: Platform,
    private promoService: PromotionService,
    private translationService: TranslationService
  ) {}


  ngOnInit() {
    this.generateVisitorId();
    this.analytics.conversionUpdate("checkoutProcess");

    //TODOCLOVER
    if (this.store.cloverPaymentInfo != null) {

      if (this.store.paymentRestriction.use3DSecure) {
        window._3DSUtil = new Clover3DS({ merchantUuid:  this.store.cloverPaymentInfo.cloverId });

        //this is proper to the clover 3ds callback
        document.addEventListener('executePatch', async (event) => {
          console.log(event);

          const loader = await this.loadingCtrl.create({
            message: this.translationService.translate("General.RefreshWarning"),
          });
          console.log("this is after the event, the call to finalize the payment, TODO");
          await loader.present();
            
           debugger;                             
                await this.orderService.place3DSOrderConfirmation(this.guestForm, true, {
                  source: "CLOVER",
                  flow_status: (event as CustomEvent).detail._3DSStatus
              })
                .pipe(finalize(async () => {
                  await loader.dismiss();
                  this.clickedSubmitted = false;
                  //await this.warningModal.dismiss();
                }))
                .subscribe(async response => { 


                  if (response.cloverRequireChallenge) {
                    debugger;
                    console.log("trigger the challenge");
                    window._3DSUtil.perform3DSChallenge({ 
                        messageVersion:       response.cloverThreeDsData.threeds_protocol_version || "2.2.0",
                        acsTransID:           response.cloverThreeDsData.acs_transaction_id,
                        acsUrl:               response.cloverThreeDsData.acs_url,
                        threeDSServerTransID: response.cloverThreeDsData.threeds_server_transaction_id,
                    });
                    return;
                  }

                  console.log("testguest3 3ds confirmation");
                  console.log(response);

                  if (!response || response.errorMessage != null) {
                    var message = this.getOrderResponseMessage(response);
                  
                    this.alertService.showCheckoutErrors(message);
                    return;
                  }

                  if (response) {
                    this.promoService.resetDiscounts();
                    await this.modalCtrl.dismiss(response);
                  }

                  
                });
        });
      }

      //if (!this.store.paymentRestriction.use3DSecure) {
        setTimeout(() => {
          let token = this.store.cloverPaymentInfo.publicToken;

          if (this.store.cloverPaymentInfo.useOAuth) {
            token = this.store.cloverPaymentInfo.pakmsToken;
          }

        const clover = new Clover(token, {
            merchantId: this.store.cloverPaymentInfo.cloverId,
            locale: 'fr-CA'
        });

        const styles = {
          body: {
            fontFamily: '"Roboto", "Helvetica Neue", sans-serif',
          // fontStyle: 'normal'
            //fontSize: '16px',
            // other body styles can be added here
          },
          input: {
            fontSize: '14px',
            color: '#333',
            padding: '6px 4px 4px 14px',
            height: '30px',
            border: '1px solid #ccc',
            borderRadius: '2px',
            // other input styles can be added here
          },
          '.input-errors': { // Style for error messages
            color: 'red',
            fontSize: '14px',
          },
          /*'#cardNumber' : {
            marginTop: '-10px'
          },*/
          /*'#date': {
            maxWidth: '50px'
          },*/
        };

      
        const elements = clover.elements();

        const form = document.getElementById('payment-form');
      
        const cardNumber = elements.create('CARD_NUMBER', styles);
        const cardName = elements.create('CARD_NAME', styles);
        const cardDate = elements.create('CARD_DATE', styles);
        const cardCvv = elements.create('CARD_CVV', styles);
        const cardPostalCode = elements.create('CARD_POSTAL_CODE', styles);
       // const cardStreetAddress = elements.create('CARD_STREET_ADDRESS');

        cardNumber.mount('#card-number');
        cardName.mount('#card-name');
        cardDate.mount('#card-date');
        cardCvv.mount('#card-cvv');
        cardPostalCode.mount('#card-postal-code');
       // cardStreetAddress.mount('#card-street-address');

        /*const paymentReqData = {
                  // Define your payment request data here
              };

         const paymentRequestButton = elements.create('PAYMENT_REQUEST_BUTTON', {
            paymentReqData
        });
        paymentRequestButton.mount('#payment-request-button');

        paymentRequestButton.addEventListener('paymentMethod', function(ev) {
            alert(JSON.stringify(ev));
        });

        paymentRequestButton.addEventListener('paymentMethodStart', function(ev) {
            console.log("Gpay in progress");
        });*/

        // Listen for form submission
        form.addEventListener('submit', (event) => {
        
          event.preventDefault();
          // Use the iframe's tokenization method with the user-entered card details
          clover.createToken()
            .then((result) => {
            if (result.errors) {
              Object.values(result.errors).forEach(function (value) {
                console.log("ERROR" + value);
                //displayError.textContent = value;
              });
            } else {
              console.log("The card tokenis: " + result.token)
              this.cloverTokenId = result.token;
            }
          });
        });
      }, 500);
    //}
  }

    this.storage.set("orderType", this.order._deliveryType);
    if (this.order._deliveryType == "delivery") {
      this.shippingAddress = JSON.parse(
        localStorage.getItem("deliveryAddress")
      );
    } else if (this.order._deliveryType == "shipping") {
      this.shippingAddress = JSON.parse(
        localStorage.getItem("shippingAddress")
      );
    }
  }

  async generateVisitorId() {

    if(!localStorage.getItem('visitorId')) {
      await this.analytics.setVisitorId();
      this.VisitorId = localStorage.getItem('visitorId');
    } else {
      this.VisitorId = localStorage.getItem('visitorId');
    }
    
  }

  loadProfile(){
    this.personalInfoFormComponent.getProfile();
  }

  searchCoupon(e) {
    this.cancel();
  }
  onGiftCardChange(form: ICheckoutGiftCardForm) {
    this.giftCard = form;
  }

  onShippingCalculated(shippingPrice: number) {
    this.shippingPrice = shippingPrice;
  }

  onTotalChanged(total: number) {
    this.total = total;
  }

  onTipChanged(form: ICheckoutTipForm) {
    this.tip = form.amount;
  }

  onTermsAgreementChanged(form: ICheckoutTermsAgreementForm) {
    this.termsAgreement = form;
  }

  onPersonalInfoFormChanged(form: ICheckoutPersonalInfoForm) {
    this.personalInformation = form;
  }

  onGuestCreditCardChanged(form: ICreditCardForm) {
    this.guestCreditCard = form;
  }

  onBillingAddressChanged(address: IAddress) {
    this.guestBillingAddress = address;
  }

  onMemberCreditCardChanged(card: ICreditCardCvc) {
    this.memberCreditCard = card;
  }

  onCheckoutNoteChange(form: ICheckoutNoteForm) {
    this.checkoutNote = form;
  }
  onSendNotificationChanged(form: IDoorDashDriveNotificationForm) {
    if (form) {
      this.SendNotificationAgreement = form.agreement;
    }
  }
  onDeliveryOptionChanged(isMeetAtDoor: boolean) {
    this.isMeetAtDoor = isMeetAtDoor;
  }
  onUtensilsChange(e){
    this.includeUtensils = e.detail.checked;
  }
  async cancel() {
    await this.modalCtrl.dismiss(null);
  }
  alertNoDelivery() {
    this.alertCtrl
      .create({
        header: this.translationService.translate(
          "Checkout.WrongPostalCodeHeading"
        ),
        message: this.translationService.translate("Checkout.WrongPostalCode"),
        buttons: [
          {
            text: "Ok",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {},
          },
        ],
      })
      .then((al) => {
        al.present();
      });
  }

  /* async showNoRefreshWarning() {
      this.warningModal = await this.modalCtrl.create({
        component: ModalDisplayComponent,
        componentProps: {
            title: "",
            content: this.translateService.instant("General.RefreshWarning"),
            showCloseBtn: false
        }
    });

    await this.warningModal.present();
  }*/

  async memberPay() {
    //prompt a modal with a message just before showing the loader
    // this.showNoRefreshWarning();

    // const loader = await this.loader.create();
    // await loader.present();

    const loader = await this.loadingCtrl.create({
      message: this.translationService.translate("General.RefreshWarning"),
    });

    await loader.present();

    if (
      this.order._deliveryType == "delivery" ||
      this.order._deliveryType == "pickup" ||
      this.order._deliveryType == 'seat'
    ) {

      this.orderService
        .memberPlaceOrder(this.memberForm)
        .pipe(
          finalize(async () => {
            await loader.dismiss();
            this.clickedSubmitted = false;
            //await this.warningModal.dismiss();
          })
        )
        .subscribe(async (response) => {
          

          this.submitted = false;
          // await this.warningModal.dismiss();
          if (!response || response.errorMessage != null) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.InvalidOrder"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });

            if (
              response.errorMessage.toLowerCase().includes("doordash drive") ||
              response.errorMessage.toLowerCase().includes("doordashdelivery")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveNotAvailable"
              );
            }
            if (
              response.errorMessage
                .toLowerCase()
                .includes("failed doordash drive validation")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveValidationError"
              );
            }
            if (
              response.errorMessage
                .toLowerCase()
                .includes("unable to create order with doordash drive")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveCreationError"
              );
            }
            if (response.errorMessage.toLowerCase().includes("the dropoff location is outside the delivery radius of the pickup location")) {
              toast.message = this.translationService.translate("Checkout.TooFarForDelivery");
            }
            if (response.errorMessage.toLowerCase().includes("failed to create location")) {
              toast.message = this.translationService.translate("Checkout.UberDirectNotAvailable");
            }
            if (response.errorMessage.toLowerCase().includes("tip exceeds max amount")) {
              toast.message = this.translationService.translate("Checkout.UberDirectTipMaxAmount");
            }
            if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
              toast.message = this.translationService.translate(
                "Checkout.StoreIsClosed"
              );
            }
            if (
              response.errorMessage.toLowerCase().includes("alreadyprocessed")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.AlreadyProcessed"
              );
            }
            if (
              response.errorMessage
                .toLowerCase()
                .includes("strictbillingaddresserror")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.StrictBillingAddressError"
              );
            }
            await toast.present();
            return;
          }

          if (response.isBlockedCard) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.BlockedCard"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });
            toast.present();
            return;
          }

          if (response.isBlockedEmail) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.BlockedEmail"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });
            toast.present();
            return;
          }

          if (response) {
            let remainingCartItems = this.order.orderItems.filter(
              (i) => i.orderType != this.order._deliveryType
            );
            if (remainingCartItems.length > 0) {
              localStorage["cartStorage"] = JSON.stringify(remainingCartItems);
              await this.modalCtrl.dismiss(response);
              return;
            }
            localStorage.removeItem("cartStorage");
            localStorage.removeItem("StoreId");
            localStorage.removeItem("TimeLimit");
            this.promoService.resetDiscounts();
            await this.modalCtrl.dismiss(response);
            return;
          }
          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.InvalidOrder"),
            position: "bottom",
            color: "danger",
            cssClass: 'order-toast',
            buttons: [
              {
                side: "start",
                icon: "alert-circle-outline",
                //cssClass: "order-error-icon",
                text: "",
                handler: () => {},
              },
              {
                text: this.translationService.translate("General.Close"),
                role: "cancel",
                handler: () => {},
              },
            ],
          });

          await toast.present();
        });
    } else if (this.order._deliveryType == "shipping") {
      this.orderService
        .memberPlaceOrderShipping(this.memberShippingForm)
        .pipe(
          finalize(async () => {
            await loader.dismiss();
            this.clickedSubmitted = false;
            //await this.warningModal.dismiss();
          })
        )
        .subscribe(async (response) => {
          this.submitted = false;
          // await this.warningModal.dismiss();
          if (!response || response.errorMessage != null) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.InvalidOrder"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });

            if (
              response.errorMessage.toLowerCase().includes("doordash drive") ||
              response.errorMessage.toLowerCase().includes("doordashdelivery")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveNotAvailable"
              );
            }
            if (
              response.errorMessage
                .toLowerCase()
                .includes("failed doordash drive validation")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveValidationError"
              );
            }
            if (
              response.errorMessage
                .toLowerCase()
                .includes("unable to create order with doordash drive")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.DoorDashDriveCreationError"
              );
            }
            if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
              toast.message = this.translationService.translate(
                "Checkout.StoreIsClosed"
              );
            }
            if (
              response.errorMessage.toLowerCase().includes("alreadyprocessed")
            ) {
              toast.message = this.translationService.translate(
                "Checkout.AlreadyProcessed"
              );
            }
            await toast.present();
            return;
          }

          if (response.isBlockedCard) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.BlockedCard"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });
            toast.present();
            return;
          }

          if (response.isBlockedEmail) {
            const toast = await this.toastCtrl.create({
              message: this.translationService.translate("Checkout.BlockedEmail"),
              position: "bottom",
              color: "danger",
              cssClass: 'order-toast',
              buttons: [
                {
                  side: "start",
                  icon: "alert-circle-outline",
                  //cssClass: "order-error-icon",
                  text: "",
                  handler: () => {},
                },
                {
                  text: this.translationService.translate("General.Close"),
                  role: "cancel",
                  handler: () => {},
                },
              ],
            });
            toast.present();
            return;
          }

          if (response) {
            let remainingCartItems = this.order.orderItems.filter(
              (i) => i.orderType != this.order._deliveryType
            );
            if (remainingCartItems.length > 0) {
              localStorage["cartStorage"] = JSON.stringify(remainingCartItems);
              await this.modalCtrl.dismiss(response);
              return;
            }
            localStorage.removeItem("cartStorage");
            localStorage.removeItem("StoreId");
            localStorage.removeItem("TimeLimit");
            this.promoService.resetDiscounts();
            await this.modalCtrl.dismiss(response);
            return;
          }
          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.InvalidOrder"),
            position: "bottom",
            color: "danger",
            cssClass: 'order-toast',
            buttons: [
              {
                side: "start",
                icon: "alert-circle-outline",
                //cssClass: "order-error-icon",
                text: "",
                handler: () => {},
              },
              {
                text: this.translationService.translate("General.Close"),
                role: "cancel",
                handler: () => {},
              },
            ],
          });
          await toast.present();
        });
    }
  }

  async guestPay() {
    /* const loader = await this.loader.create();
    await loader.present();*/

    const loader = await this.loadingCtrl.create({
      message: this.translationService.translate("General.RefreshWarning"),
    });

    await loader.present();

    // if fully paid with giftcard, no need 3dsecure
    if (this.store.paymentRestriction.use3DSecure && !this.isGiftCardFullyCover) {
      //do special stuff for 3D secure here, we need to trigger place order without any form of payment, but dont forget to take coupons and gift card into consideration
      //so we need a first call to do all the placeOrder validation without creating the order, and a second call to complete a transaction once the challenge was completed

      console.log("testguest1");
      

      this.orderService
          .place3DSOrderValidation(this.guestForm)
          .pipe(finalize(async () => {
            await loader.dismiss();           
            //await this.warningModal.dismiss();
          }))
          .subscribe(async response => {
            console.log("testguest2 3ds");
            console.log(response);

            this.submitted = false;
          
            // await this.warningModal.dismiss();
            if (!response || response.errorMessage != null) {               
              var message = this.getOrderResponseMessage(response);
              this.alertService.showCheckoutErrors(message);
              return;
            }

            if (response.isBlockedCard) {
              this.clickedSubmitted = false;
              var message = this.translationService.translate("Checkout.BlockedCard");              
              this.alertService.showCheckoutErrors(message);
              return;
            }

            if (response.isBlockedEmail) {
              this.clickedSubmitted = false;
              var message = this.translationService.translate("Checkout.BlockedEmail");
              this.alertService.showCheckoutErrors(message);
              return;
            }

            if (response && this.store.cloverPaymentInfo == null) {
              //this is the realex 3ds payment flow

              this.orderId = response.orderId;
              this.giftTrsConsNumber = response.giftCardConsNumber;
              //await this.modalCtrl.dismiss(response);
              //star the 3ds process
              try {
                await loader.present();
                var checkVersionUrl = this.settingService.getLegacySmaUrl("GlobalThreeDS/CheckVersion");

                //this is only for dev because the globalpayment 3DS challengeEndpoint doesnt support localhost so i had
                //to setup a fake dns for localhost:9100
                checkVersionUrl = checkVersionUrl.replace("localhost", "legacy-api.com");

                //debugger;
               // var t =  moment(this.guestForm.creditCard.expirationDate).format("MM");
                //var y =  moment(this.guestForm.creditCard.expirationDate).format("YYYY")

                var versionCheckData: any = await GlobalPayments.ThreeDSecure.checkVersion(checkVersionUrl, {
                  card: {
                     number: this.guestForm.creditCard.number
                  },
                  terminal : this.store.terminalId,
                  subdomain: HttpHelpers.getSubdomain()
               });


                if (versionCheckData.error || versionCheckData == null) {
                  await loader.dismiss();
                  this.clickedSubmitted = false;
                  // TODO: handle the scenario where the card is not enrolled for 3D Secure 2             
                  this.alertService.showMessage( this.translationService.translate("3DS.3DSNOTSUPPORTED"), 'bottom', 6000, 'danger');
                  return;
                }

                var initiateAuthUrl = this.settingService.getLegacySmaUrl("GlobalThreeDS/ThreeDSecureInitiateAuth");

                //this is only for dev because the globalpayment 3DS challengeEndpoint doesnt support localhost so i had
                //to setup a fake dns for localhost:9100
                initiateAuthUrl = initiateAuthUrl.replace("localhost", "legacy-api.com");

                //await loader.present();
                var authenticationData:any = await GlobalPayments.ThreeDSecure.initiateAuthentication(initiateAuthUrl, {
                serverTransactionId: versionCheckData.serverTransactionId,
                methodUrlComplete: true,
                card: {
                    expiryMonth: moment(this.guestForm.creditCard.expirationDate).format("MM"),
                    expiryYear: moment(this.guestForm.creditCard.expirationDate).format("YYYY"),
                    securityCode: this.guestForm.creditCard.cvnNumber,         
                    cardHolderName: this.guestForm.creditCard.cardHolderName,
                  // number:  "4263970000005262",//no challenge
                  number: this.guestForm.creditCard.number //challenge

                },       
                challengeWindow: {
                    windowSize: GlobalPayments.ThreeDSecure.ChallengeWindowSize.Windowed500x600,
                    displayMode: 'lightbox',
                },
                browserData: GlobalPayments.ThreeDSecure.getBrowserData(),
                terminal : this.store.terminalId,
                billingAddress: {
                  streetAddress1 : this.guestBillingAddress.streetNumber + " " + this.guestBillingAddress.streetType + " " + this.guestBillingAddress.street,
                  city : this.guestBillingAddress.city,
                  postalCode : this.guestBillingAddress.postalCode,
                  state : this.guestBillingAddress.province,
                  country : "CA"
                },
                amount: response.amountLeftToPay,
                email: this.guestForm.customerEmail,
                phone: this.guestForm.phone
              });

              await loader.dismiss();
              
              if (authenticationData.result == "INITIATE_AUTHENTICATION_FAILED") {
                  this.clickedSubmitted = false;
                  // TODO: show according error message
                  this.alertService.showCheckoutErrors( this.translationService.translate("3DS.INITAUTHFAILED"));
              }           
              else if (authenticationData.result == "NO_CHALLENGE_REQUIRED_AUTOBLOCKED") {
                  this.clickedSubmitted = false;
                   // TODO: show according error message
                   this.alertService.showCheckoutErrors( this.translationService.translate("3DS.NOCHALLENGEREQUIRED"));
              }
             

              else if (authenticationData.challenge.response.data.transStatus == "Y") {

                this.threeDSTransactionId = authenticationData.challenge.response.data.threeDSServerTransID;
                document.querySelectorAll('.hide-global-logo').forEach(e => e.remove());
                await this.orderService.place3DSOrderConfirmation(this.guestForm)
                .pipe(finalize(async () => {
                  await loader.dismiss();
                  this.clickedSubmitted = false;
                  //await this.warningModal.dismiss();
                }))
                .subscribe(async response => { 

                  console.log("testguest3 3ds confirmation");
                  console.log(response);

                  if (!response || response.errorMessage != null) {
                    var message = this.getOrderResponseMessage(response);                  
                    this.alertService.showCheckoutErrors(message);
                    return;
                  }

                  if (response) {
                    this.promoService.resetDiscounts();
                    await this.modalCtrl.dismiss(response);
                  }

                  
                });              
              }

              // challenge failure
              else {
                document.querySelectorAll('.hide-global-logo').forEach(e => e.remove());
                this.clickedSubmitted = false;
                // TODO: show according error message
                this.alertService.showCheckoutErrors( this.translationService.translate("3DS.CHALLENGEFAILED"));
                // TODO: proceed to failure page or display failed authentication information
                return false;
              }
              return;
            }
            catch (exp) {
              console.log(exp);
          
            }
          }  else if(response && this.store.cloverPaymentInfo != null) {
            debugger;
              //this is the clover 3ds flow
              this.orderId = response.orderId;

               this.orderService
                  .cloverCreate3DSCharge(this.guestForm, window._3DSUtil.getBrowserInfo(), this.settingService.ipAddress)
                  .pipe(finalize(async () => {
                    await loader.dismiss();           
                    //await this.warningModal.dismiss();
                  }))
                  .subscribe(async response => {
                      if (response.threeds != null) {
                        this.threeDSTransactionId = response.id;
                       
                          if (response.threeds.validation_result == "THREEDS_METHOD_FLOW_REQUIRED") {
                            window._3DSUtil.perform3DSFingerPrinting({ 
                                threeDSServerTransID: response.threeds.data.threeds_server_transaction_id,
                                threeDSMethodUrl: response.threeds.data.method_url,
                                methodNotificationUrl: response.threeds.data.method_notification_url,
                              });
                          }

                          if (response.threeds.validation_result == "CHALLENGE_FLOW_REQUIRED") {
                              window._3DSUtil.perform3DSChallenge({ 
                                 messageVersion:       response.threeds.data.threeds_protocol_version || "2.2.0",
                                  acsTransID:           response.threeds.data.acs_transaction_id,
                                  acsUrl:               response.threeds.data.acs_notification_url,
                                  threeDSServerTransID: response.threeds.data.threeds_server_transaction_id,
                              });
                          }

                      } else {
                          //it passed without a required challenge, lets call the auth confirm right away
                        await this.orderService.place3DSOrderConfirmation(this.guestForm, true)
                        .pipe(finalize(async () => {
                          await loader.dismiss();
                          this.clickedSubmitted = false;
                          //await this.warningModal.dismiss();
                        }))
                        .subscribe(async response => { 

                        console.log("testguest3 3ds confirmation");
                        console.log(response);

                        if (!response || response.errorMessage != null) {
                          var message = this.getOrderResponseMessage(response);                      
                          this.alertService.showCheckoutErrors(message);
                          return;
                        }

                        if (response) {
                          this.promoService.resetDiscounts();
                          await this.modalCtrl.dismiss(response);
                        }

                        
                      });

                    }

                  });

          }          
        });
    } else {
      if (
        this.order._deliveryType == "delivery" ||
        this.order._deliveryType == "pickup" ||
        this.order._deliveryType == "seat"
      ) {
        this.orderService
          .placeOrder(this.guestForm)
          .pipe(
            finalize(async () => {
              await loader.dismiss();
              this.clickedSubmitted = false;
              //await this.warningModal.dismiss();
            })
          )
          .subscribe(async (response) => {
            console.log("testguest2 no_3ds");
            console.log(response);

            this.submitted = false;
            // await this.warningModal.dismiss();
            if (!response || response.errorMessage != null) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.InvalidOrder"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              if (
                response.errorMessage.toLowerCase().includes("doordash drive") ||
                response.errorMessage.toLowerCase().includes("doordashdelivery")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveNotAvailable"
                );
              }
              if (
                response.errorMessage
                  .toLowerCase()
                  .includes("failed doordash drive validation")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveValidationError"
                );
              }
              if (
                response.errorMessage
                  .toLowerCase()
                  .includes("unable to create order with doordash drive")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveCreationError"
                );
              }
              if (response.errorMessage.toLowerCase().includes("the dropoff location is outside the delivery radius of the pickup location")) {
                toast.message = this.translationService.translate("Checkout.TooFarForDelivery");
              }
              if (response.errorMessage.toLowerCase().includes("failed to create location")) {
                toast.message = this.translationService.translate("Checkout.UberDirectNotAvailable");
              }
              if (response.errorMessage.toLowerCase().includes("tip exceeds max amount")) {
                toast.message = this.translationService.translate("Checkout.UberDirectTipMaxAmount");
              }

              if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
                toast.message = this.translationService.translate(
                  "Checkout.StoreIsClosed"
                );
              }
              if (
                response.errorMessage.toLowerCase().includes("alreadyprocessed")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.AlreadyProcessed"
                );
              }

              await toast.present();
              return;
            }

            if (response.isBlockedCard) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.BlockedCard"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              toast.present();
              return;
            }

            if (response.isBlockedEmail) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.BlockedEmail"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              toast.present();
              return;
            }

            if (response) {
              //success
              this.promoService.resetDiscounts();

              await this.modalCtrl.dismiss(response);
              return;
            }
          });
      } else if (this.order._deliveryType == "shipping") {
        this.orderService
          .placeOrderShipping(this.guestShippingForm)
          .pipe(
            finalize(async () => {
              await loader.dismiss();
              this.clickedSubmitted = false;
              //await this.warningModal.dismiss();
            })
          )
          .subscribe(async (response) => {
            this.submitted = false;
            // await this.warningModal.dismiss();
            if (!response || response.errorMessage != null) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.InvalidOrder"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              if (
                response.errorMessage.toLowerCase().includes("doordash drive") ||
                response.errorMessage.toLowerCase().includes("doordashdelivery")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveNotAvailable"
                );
              }
              if (
                response.errorMessage
                  .toLowerCase()
                  .includes("failed doordash drive validation")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveValidationError"
                );
              }
              if (
                response.errorMessage
                  .toLowerCase()
                  .includes("unable to create order with doordash drive")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.DoorDashDriveCreationError"
                );
              }

              if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
                toast.message = this.translationService.translate(
                  "Checkout.StoreIsClosed"
                );
              }
              if (
                response.errorMessage.toLowerCase().includes("alreadyprocessed")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.AlreadyProcessed"
                );
              }
              if (
                response.errorMessage
                  .toLowerCase()
                  .includes("strictbillingaddresserror")
              ) {
                toast.message = this.translationService.translate(
                  "Checkout.StrictBillingAddressError"
                );
              }

              await toast.present();
              return;
            }

            if (response.isBlockedCard) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.BlockedCard"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              toast.present();
              return;
            }

            if (response.isBlockedEmail) {
              const toast = await this.toastCtrl.create({
                message: this.translationService.translate("Checkout.BlockedEmail"),
                position: "bottom",
                color: "danger",
                cssClass: 'order-toast',
                buttons: [
                  {
                    side: "start",
                    icon: "alert-circle-outline",
                    //cssClass: "order-error-icon",
                    text: "",
                    handler: () => {},
                  },
                  {
                    text: this.translationService.translate("General.Close"),
                    role: "cancel",
                    handler: () => {},
                  },
                ],
              });
              toast.present();
              return;
            }

            if (response) {

              this.promoService.resetDiscounts();
              await this.modalCtrl.dismiss(response);
              return;
            }
          });
      }
    }
  }

  pay() {
    // before paying, update the account ID
    this.getProfile();

    //Valid if we have all the info
    this.submitted = true;
    this.clickedSubmitted = true;

    if (this.isFormValid) {
      //Only proceed when all forms are valids
      if (this.auth.isAuthenticated && !this.store.paymentRestriction.use3DSecure) {
        //we force the members to use the guest form when the store is set to 3DSecure
        if (this.memberCreditCard) {
          if (this.memberCreditCard.Card) {
            if (
              this.store.address.province !=
              this.memberCreditCard.Card.Address.province
            ) {
              let addressValid = 1;
              //Store logic
              if (this.store.allowedProvince != null) {
                if (!this.store.allowedProvince.allowOtherProvince) {
                  this.alertNoDelivery();
                  return;
                } else {
                  addressValid =
                    this.store.allowedProvince.allowedProvinces.findIndex(
                      (province) =>
                        province == this.memberCreditCard.Card.Address.province
                    );
                  if (addressValid < 0) {
                    this.alertNoDelivery();
                    return;
                  }
                }
              }
              //Merchant Logic
              else {
                if (this.settingService.configuration.allowedProvince != null) {
                  if (
                    !this.settingService.configuration.allowedProvince
                      .allowedProvinces
                  ) {
                    this.alertNoDelivery();
                    return;
                  } else {
                    addressValid =
                      this.settingService.configuration.allowedProvince.allowedProvinces.findIndex(
                        (province) =>
                          province ==
                          this.memberCreditCard.Card.Address.province
                      );
                    if (addressValid < 0) {
                      this.alertNoDelivery();
                      return;
                    }
                  }
                }
              }
            }
          }
        }

        

        if (!this.isGiftCardFullyCover && !this.memberCreditCard && this.store.cloverPaymentInfo == null) {
          this.alertService.showTranslate(
            "Checkout.NoCreditCardSelected",
            "bottom",
            6000,
            "danger"
          );
          this.submitted = false;
        } else {
          this.memberPay();
        }
        return;
      }

      this.guestPay();
    } else {
      this.clickedSubmitted = false;
    }
  }


  ///////////////////////////////////////////////////////////////////////////////
  // this is all for the "underMinimumOrderValue"
  underMinimumOrderValue(): boolean{
    if(this.order._deliveryType == 'seat') {
      var subtotal = this.calculateTotal();

      if(subtotal > this.settingService.configuration.minPickupAmount) {
        this.overMinimumPickupSeatAmount = false;
        return false;
      } else {
        this.overMinimumPickupSeatAmount = true;
        return true;
      }
    }

    if(this.order._deliveryType == 'pickup') {
      var subtotal = this.calculateTotal();

      if(subtotal > this.settingService.configuration.minPickupAmount) {
        this.overMinimumPickupSeatAmount = false;
        return false;
      } else {
        this.overMinimumPickupSeatAmount = true;
        return true;
      }
    }
 

    if(this.order._deliveryType == 'delivery') {
      var subtotal = this.calculateTotal();

      if(subtotal > this.store.deliveryMinAmount) {
        //this.overMinimumPickupAmount = false;
        return false;
      } else {
        //this.overMinimumPickupAmount = true;
        return true;
      }
    }

    //this.overMinimumPickupAmount = false;
    return false;
  }

  private calculateTotal() {
    let total: number = 0;

    //Remove all the non-taxable item from the subtotal to do the tax calculation
    let nonTaxableAmount = this.getNonTaxableTotal();
    let subTotal = this.totalOptions.subTotal + this.totalOptions.convenienceFee;    
    subTotal -= nonTaxableAmount;

    if(this.order._deliveryType == 'delivery'){
      total += this.totalOptions.deliveryFee;
      subTotal += this.totalOptions.deliveryFee;
    }

    return subTotal;
  }

  private getNonTaxableTotal() {
    let amount = 0;

    if (this.order) {
      for (let i = 0; i < this.order.orderItems.length; i++) {
        if(this.order.orderItems[i]){
          if(this.order.orderItems[i].orderType == this.order._deliveryType){
            if (!this.order.orderItems[i].taxEligible) {
              amount += this.order.orderItems[i].price * this.order.orderItems[i].quantity;
    
              //Dont forget to add the options value, since the item is non-taxable, we cant charge tax on the options
              for( let j = 0; j < this.order.orderItems[i].options.length; j++) {
                amount += this.order.orderItems[i].options[j].price * this.order.orderItems[i].options[j].quantity;
              }
            }
          }
        }
      }
    }
   
    return amount;
  }

  getProfile() {
    // get the profile.
    this.profileService.getProfile()
      .subscribe((profile) => {
       this.memberProfile = profile;
      },
        () => {

        });
  }

  getOrderResponseMessage(response: ICustomerTransactionEmail) {
      this.clickedSubmitted = false; 
      var message = this.translationService.translate("Checkout.InvalidOrder");                        
      if (response.errorMessage.toLowerCase().includes("doordash drive") || response.errorMessage.toLowerCase().includes("doordashdelivery")) {
        message = this.translationService.translate("Checkout.DoorDashDriveNotAvailable");
      }
      if (response.errorMessage.toLowerCase().includes("failed doordash drive validation")) {
        message = this.translationService.translate("Checkout.DoorDashDriveValidationError");
      }
      if (response.errorMessage.toLowerCase().includes("unable to create order with doordash drive")) {
        message = this.translationService.translate("Checkout.DoorDashDriveCreationError");
      }
      if (response.errorMessage.toLowerCase().includes("the dropoff location is outside the delivery radius of the pickup location")) {
        message = this.translationService.translate("Checkout.TooFarForDelivery");
      }
      if (response.errorMessage.toLowerCase().includes("failed to create location")) {
        message = this.translationService.translate("Checkout.UberDirectNotAvailable");
      }
      if (response.errorMessage.toLowerCase().includes("tip exceeds max amount")) {
        message = this.translationService.translate("Checkout.UberDirectTipMaxAmount");
      }

      if (response.errorMessage.toLowerCase().includes("storeisclosed")) {
        message = this.translationService.translate("Checkout.StoreIsClosed");
      }
      if (response.errorMessage.toLowerCase().includes("alreadyprocessed")) {
        message = this.translationService.translate("Checkout.AlreadyProcessed");
      }
      if (response.errorMessage.toLowerCase().includes("paymentrestrictionreached")) {
        message = this.translationService.translate("Checkout.PaymentRestrictionReachedError");
      }

      return message;
  }

   ///////////////////////////////////////////////////////////////////////////////
}
